// based on rc-calendar 9.8.2
import Calendar from './src/';
export default Calendar;
